import React, { useMemo, useCallback, useState, useEffect } from 'react'
import globalConfig from 'Helper/configHelpers'
import { useNavigate } from 'react-router-dom'
import { jwtVerify, importSPKI } from 'jose'
import { useDispatch } from 'react-redux'
import { addToClickLog } from 'actions/logActions'


const AuthProviderSelector = ({ startAuthorizationGrant, authProvider, subProvider, message='', clearAuthError = () => null }) => {
  const navigate = useNavigate()
  const [messageContent, setMessageContent] = useState('')
  const availableAuthProviders = globalConfig.auth_providers
  const getName = Provider => Provider.charAt(0).toUpperCase() + Provider.slice(1)
  const dispatch = useDispatch()


  useEffect(() => {
    if(!message || message === '') {
      // do nothing.
    } else 
    if(message.toLowerCase() === 'unknown') {
      setMessageContent('Unknown authentication error. Please contact your system Administrator if the problem persists.')
      dispatch(addToClickLog({ event: "Login: Unknown authentication error" }))
    } else {
      importSPKI(globalConfig.publicKey, 'RS256').then(publicKey => {
          // if its a backend message it came as a jwt
          jwtVerify(message, publicKey, {
            issuer: globalConfig.api_base_url.replace('/api', '')
          }).then((token, protectedHeader) => {
            dispatch(addToClickLog({ event: "Login: Unexpected authentication error." }))
            let { message = 'Unexpected authentication error. Please contact your system Administrator if the problem persists.', errors = {}} = token.payload
            const newContent = (
              <>
                {message}
                <ul>
                  {Object.keys(errors).map((property, idx) => {
                    return (
                      <li key={`${property}-${idx}`}>{property}:
                        <ul>
                          {errors[property].map((valError, idx2) => <li key={`${valError}-${idx2}`}>{valError}</li>)}
                        </ul>
                      </li>)
                    })
                  }
                </ul>
              </>
            )
            setMessageContent(newContent)
          }).catch(e => {
            // it might be a frontend message so just show it. 
            setMessageContent(message)
          })
      })
    }
  }, [message])

  const authButton = useCallback((Provider, key = 0) => {
    let nextAction = () => startAuthorizationGrant(Provider, subProvider)
    if (Provider === 'summit') {
      nextAction = () => {clearAuthError(); navigate('/summit/login')}
    }
    return (
      <button
        key={key}
        type="submit"
        aria-label={`Login via ${getName(Provider)}`}
        className="btn btn-warning btn-lg login-button"
        onClick={nextAction}
      >
        {`Login via ${getName(Provider)}`}
      </button>
    )
  }, [subProvider])

  const Buttons = useMemo(() => {
    if (authProvider != null) {
      // they manually typed in a URL so show them only that option.
      return authButton(authProvider)
    } else {
      return availableAuthProviders.map((Provider, index) => {
        return authButton(Provider, index)
      })
    }
  }, [authProvider, availableAuthProviders])

  return (
    <React.Fragment>
      <h1>{'Sign In'}</h1>
      <div className="login-text error">{messageContent}</div>
      <div className='auth-buttons'>
      {Buttons}
      </div>
    </React.Fragment>
  )
}

export default AuthProviderSelector
